import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Avatar, Box, Divider, TextField, Typography, useTheme } from '@mui/material';
import PriorityHighRoundedIcon from '@mui/icons-material/PriorityHighRounded';

// Components
import { MDialog } from '..';

// Styles
import {
  avatarStyles,
  confirmationMessageStyles,
  confirmationValueStyles,
  dialogContainerStyles,
  inputSubCaptionStyles,
  warningTextStyles,
} from './DialogExplicitConfirmation.styles';

const DialogExplicitConfirmation = ({
  title,
  warningList,
  confirmationMessage,
  confirmationValue,
  dialogOpen,
  handleCloseDialog,
  onConfirm,
  label,
}) => {
  const [explicitText, setExplicitText] = useState('');
  const theme = useTheme();

  const handleExplicitTextChange = e => {
    setExplicitText(e.target.value);
  };

  const handleClose = () => {
    setExplicitText('');
    handleCloseDialog();
  };

  const handleConfirm = () => {
    setExplicitText('');
    onConfirm();
  };

  return (
    <MDialog
      data-testid="dialog-explicit-confirmation"
      header={title}
      leftButtonAction={handleClose}
      leftButtonText="Back"
      onClose={handleClose}
      open={dialogOpen}
      rightButtonAction={handleConfirm}
      rightButtonDisabled={explicitText !== confirmationValue}
      rightButtonText="Confirm"
      slotProps={{ paper: { sx: dialogContainerStyles } }}
    >
      {warningList?.map((error, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box display="flex" key={`${error}-${i}`} marginBottom={theme.spacing(2)}>
          <Avatar sx={{ ...avatarStyles(theme) }}>
            <PriorityHighRoundedIcon
              sx={{
                color: 'warning.dark',
                fontSize: 16,
              }}
            />
          </Avatar>
          <Typography sx={{ ...warningTextStyles }} variant="body2">
            {error}
          </Typography>
        </Box>
      ))}
      <Divider />
      {confirmationMessage && (
        <Typography sx={{ ...confirmationMessageStyles(theme) }} variant="body2">
          {confirmationMessage}
        </Typography>
      )}
      {confirmationValue && (
        <>
          <Box alignItems="center" display="flex" justifyContent="center">
            <Typography sx={{ ...confirmationValueStyles(theme) }} variant="subtitle1">
              {`"${confirmationValue}"`}
            </Typography>
          </Box>
          <Box data-testid="explicit-confirmation-input" display="flex" flexDirection="column">
            {label ? (
              <TextField label={label} onChange={handleExplicitTextChange} value={explicitText} />
            ) : (
              <TextField onChange={handleExplicitTextChange} value={explicitText} />
            )}
            <Typography sx={{ ...inputSubCaptionStyles(theme) }} variant="caption">
              Case Sensitive
            </Typography>
          </Box>
        </>
      )}
    </MDialog>
  );
};

DialogExplicitConfirmation.propTypes = {
  confirmationMessage: PropTypes.string,
  confirmationValue: PropTypes.string,
  dialogOpen: PropTypes.bool,
  handleCloseDialog: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  warningList: PropTypes.arrayOf(PropTypes.string),
};

DialogExplicitConfirmation.defaultProps = {
  confirmationMessage: null,
  confirmationValue: null,
  dialogOpen: false,
  label: false,
  title: null,
  warningList: null,
};

export default DialogExplicitConfirmation;
